export enum UploadTypeEnum {
  DEFAULTERS = "DEFAULTERS",
  COMMISSIONS = "COMMISSIONS",
}

export enum UploadStatusEnum {
  ALL = "",
  CREATED = "CREATED",
  CONVERSION_FAILED = "CONVERSION_FAILED",
  CONVERTED = "CONVERTED",
  FAILED = "FAILED",
  PROCESSING = "PROCESSING",
  VALIDATING = "VALIDATING",
  VALIDATE_ERROR = "VALIDATE_ERROR",
  VALIDATED = "VALIDATED",
  SKIPPED = "SKIPPED",
  PROCESSED = "PROCESSED",
  ERROR = "ERROR",
  UPLOADED = "UPLOADED",
  DELETED = "DELETED",
}

export const uploadStatuses = [
  {
    label: "Todos",
    value: "",
  },
  {
    label: "Processado",
    value: UploadStatusEnum.PROCESSED,
  },
  {
    label: "Erro",
    value: UploadStatusEnum.ERROR,
  },
  {
    label: "Falhou",
    value: UploadStatusEnum.FAILED,
  },
  {
    label: "Enviado",
    value: UploadStatusEnum.UPLOADED,
  },
  {
    label: "Criado",
    value: UploadStatusEnum.CREATED,
  },
  {
    label: "Conversão falhou",
    value: UploadStatusEnum.CONVERSION_FAILED,
  },
  {
    label: "Convertido",
    value: UploadStatusEnum.CONVERTED,
  },
  {
    label: "Processando",
    value: UploadStatusEnum.PROCESSING,
  },
  {
    label: "Validando",
    value: UploadStatusEnum.VALIDATING,
  },
  {
    label: "Erro ao validar",
    value: UploadStatusEnum.VALIDATE_ERROR,
  },
  {
    label: "Validado",
    value: UploadStatusEnum.VALIDATED,
  },
  {
    label: "Pulado",
    value: UploadStatusEnum.SKIPPED,
  },
]
